// NATIVE 
import * as React from 'react';


// INSTALLED 
import { Grid } from '@mui/material';
import { Formik, Form } from 'formik';
import { useDispatch } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';


// CUSTOM 
import { SnackAlert } from '../../SnackAlert';
import MultipleSnackbars from '../../MultipleSnackbars';
import { ModalSessionExpired } from '../../generics/ModalSessionExpired';
import { closeSessionGlobal, hasPemissions } from '../../../commons/utils';
import { storeCreateNovedadesTurno } from '../../../store/novedadesTurnos';
import { CreateNovedadTurno } from '../../novedadesTurno/crear/CreateNovedadTurno';
import validationSchema from '../../novedadesTurno/formModels/crear/validationSchema';
import formInitialValues from '../../novedadesTurno/formModels/crear/formInitialValues';
import createNovedadTurnoFormModel from '../../novedadesTurno/formModels/crear/createNovedadTurnoFormModel';
import { timeToClosedToast } from '../../../commons';





const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));





/**
 * CreateDialogNovedadesTurnos component renders a dialog for creating a new "Novedad Turno".
 * It handles form submission, validation, and displays various alerts based on the response.
 * 
 * @param {object} props - The properties passed to the component.
 * @param {boolean} props.open - Determines if the dialog is open.
 * @param {function} props.handleCloseDialogNovedad - Function to handle closing the dialog.
 * @param {boolean} [props.buttons=false] - Optional prop to determine if buttons should be displayed.
 * 
 * @returns {JSX.Element} The rendered CreateDialogNovedadesTurnos component.
 * 
 * @example
 * <CreateDialogNovedadesTurnos 
 *   open={true} 
 *   handleCloseDialogNovedad={handleClose} 
 *   buttons={true} 
 * />
 */
export const CreateDialogNovedadesTurnos = (props:any) =>  {


  // USE DISPATCH 
  const dispatch = useDispatch();


  // USE STATE 
  const  [isSubmitting, setIsSubmitting] = React.useState(false);
  const  [btnText, setBtnText] = React.useState('Crear Novedad Turno');
  const [percentaje_area, setPercentajeArea] = React.useState(0);



  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [messagesAlerts, setMessagesAlerts] = React.useState<any>([]);


  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);


  const [alert_snack, setAlertSnack] = React.useState(false);
  const [msgSnack, setMsgSnack] = React.useState({
      msg: '',
      status: 'success'
  });

  

  // PROPS 
  const{ open, handleCloseDialogNovedad, buttons = false } = props;


  // FORM FIELDS 
  const { formId, formField } = createNovedadTurnoFormModel;


  // VALIDATION SCHEMA 
  const currentValidationSchema = validationSchema[0];




  

  // CONST FUNCTIONS 
  const handleCloseT = () => {
    handleCloseDialogNovedad(false);
  };


  const _handleSubmit = async(values:any, actions:any) => {     
   


    const havePermissions = await hasPemissions('modulo.thumano', 'modulo.novedades', 'create', 'modulo.novedadesturnos');


    if( !havePermissions ){
      
      await validateLsPermissions('No tienes pemisos para (Crear) novedad turno.');

      return false;

    }


    setIsSubmitting(true);
    setBtnText('Un momento...')

    actions.setSubmitting(true);


    const response = await dispatch( storeCreateNovedadesTurno(values, setPercentajeArea) );


    const result = await validateResponseCreate(response, ' (Editar Tipo Novedad.) ');

    setBtnText('Crear Novedad Turno')
    setIsSubmitting(false);

    if (!result) {
      return false;
    }

   

    if ( response.ok ) {

      const errors:any = {
        msg: response.message,
        status: 'success'
      };
    
      await setMsgSnack(errors);
      await setAlertSnack(true);

      actions.resetForm();
      actions.setSubmitting(false);
      handleCloseDialogNovedad(false);
      return false;

    }


    
  }


  const validateLsPermissions = async(message:string) => {

    const errors:any = {
      msg: message,
      status: 'error'
    };
  
    await setMsgSnack(errors);
    await setAlertSnack(true);
  
  
  }



  const validateResponseCreate = async(response:any, textActionConcat: string) => {
        
        
      if (  response.code == 401  ) {
        await localStorage.removeItem('lastSelectedQypht');
        await closeSessionGlobal();
        await handleCloseDialogNovedad(false);
        setModalSessionExpired(true);
        return false;
      }

    
      // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION 
      if (!response.ok && response.code == 403 ) { 

      
        const errors:any = {
          msg: response.errors[0]+' '+textActionConcat,
          status: 'error'
        };
      
        await setMsgSnack(errors);
        await setAlertSnack(true);

      
        return false;
        
      }


      // 403 EL DATO YA SE ENCUENTRA REGISTRADO
      if (!response.ok && response.code == 409 ) { 
    
        const errors:any = {
            msg: response.errors[0]+' '+textActionConcat,
            status: 'error'
        };
        
        await setMsgSnack(errors);
        await setAlertSnack(true);

        return false;
      }

      
      // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO 
      if (!response.ok && response.code == 400 ) { 

        const errors:any = [];

        response.errors.forEach( (element:any) => {
            
            errors.push({
              type: 'error',
              text: element
            })
        });

          
        setMessagesAlerts(errors);
        return false;

      }

      return true;
    
  } 


  return (
    <React.Fragment>

      <ModalSessionExpired  open={modalSessionExpired}  />

      <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />

      <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>
      
      <BootstrapDialog
        onClose={handleCloseT}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth={'md'}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
           Crear  Novedad Turno 
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseT}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
        
   
        <Grid  >
            <Formik 
              initialValues={formInitialValues}
              validationSchema={currentValidationSchema}
              onSubmit={_handleSubmit}>

              <>
                 <Form id={formId}>
                 <CreateNovedadTurno formField={formField}/>
                 
                  
                  <Button
                    disabled={isSubmitting}
                    style={{margin:5, float: 'right'}}
                    type="submit"
                    variant="contained"
                    color={ "primary"}
                  >
                    {
                      btnText
                    } 
                </Button>
                </Form>
              </>

            </Formik>
        </Grid>
       
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}